import React, { useEffect, createElement } from 'react';
import { Hero } from './sections/Hero';
import { TrustBar } from './sections/TrustBar';
import { ProblemAgitation } from './sections/ProblemAgitation';
import { ProductTransformation } from './sections/ProductTransformation';
import { Authority } from './sections/Authority';
import { ValueStack } from './sections/ValueStack';
import { Testimonials } from './sections/Testimonials';
import { Guarantee } from './sections/Guarantee';
import { FAQ } from './sections/FAQ';
import { Closing } from './sections/Closing';
import { PurchaseNotification } from './components/PurchaseNotification';
import { StickyMobileCTA } from './components/StickyMobileCTA';
export function App() {
  // Meta Pixel Integration
  useEffect(() => {
    // Inject Meta Pixel base code
    const script = document.createElement('script');
    script.innerHTML = `
      !function(f,b,e,v,n,t,s)
      {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
      n.callMethod.apply(n,arguments):n.queue.push(arguments)};
      if(!f._fbq)f.fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
      n.queue=[];t=b.createElement(e);t.async=!0;
      t.src=v;s=b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t,s)}(window, document,'script',
      'https://connect.facebook.net/en_US/fbevents.js');
      
      fbq('init', '1206060111307086');
      fbq('track', 'PageView');
    `;
    document.head.appendChild(script);
    const noscript = document.createElement('noscript');
    noscript.innerHTML = `<img height="1" width="1" style="display:none" src="https://www.facebook.com/tr?id=1206060111307086&ev=PageView&noscript=1"/>`;
    document.head.appendChild(noscript);
    // AddToCart tracking is now handled directly via onClick on each buy button
    // in ValueStack.tsx, Closing.tsx, and StickyMobileCTA.tsx
  }, []);
  return <div className="min-h-screen bg-surface font-sans text-graphite selection:bg-primary/20" data-id="element-0">
      <main data-id="element-1">
        <Hero data-id="element-2" />
        <TrustBar data-id="element-3" />
        <ProblemAgitation data-id="element-4" />
        <ProductTransformation data-id="element-5" />
        <ValueStack data-id="element-6" />
        <Authority data-id="element-7" />
        <Testimonials data-id="element-8" />
        <Guarantee data-id="element-9" />
        <FAQ data-id="element-10" />
        <Closing data-id="element-11" />
      </main>

      {/* Overlays */}
      <PurchaseNotification data-id="element-12" />
      <StickyMobileCTA data-id="element-13" />
    </div>;
}
// Add TypeScript definition for fbq
declare global {
  interface Window {
    fbq: any;
  }
}